import styled from 'styled-components/macro';

import HeadingBase from '@components/common/core/DataDisplay/Heading';
import TextBase from '@components/common/core/DataDisplay/Text';
import LabelBase from '@components/common/core/DataDisplay/Label';
import InputGroupBase from '@components/common/core/Inputs/InputGroup';

export const TutorialStep = styled.li`
  color: ${({ theme }) => theme.colors.font};
  font-size: 1rem;
  font-weight: 400;
  font-family: ${({ theme }) => theme.fonts.body};
`;

export const TutorialList = styled.ul`
  margin: unset;
  padding: unset;
  padding-left: 24px;
  margin-bottom: 48px;
`;

export const InputGroup = styled(InputGroupBase)`
  &:not(:last-child) {
    margin-bottom: 24px;
  }
`;

export const Label = styled(LabelBase)`
  font-weight: 400;
`;

export const TutorialText = styled(TextBase)``;

export const TutorialHeading = styled(HeadingBase)`
  margin-bottom: 8px;
`;

export const TutorialWrapper = styled.div`
  margin-bottom: 40px;
`;

export const FunctionalityDescriptionText = styled(TextBase)``;

export const FunctionalityDescriptionHeading = styled(HeadingBase)`
  margin-bottom: 8px;
`;

export const FunctionalityDescriptionWrapper = styled.div`
  margin-bottom: 48px;
`;

export const Heading = styled(HeadingBase)`
  margin-left: 16px;
`;

export const Header = styled.div`
  margin-bottom: 40px;
  padding-bottom: 16px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray[3]};
`;

export const ContentWrapper = styled.div`
  max-width: 487px;
  width: 100%;
  margin-bottom: 108px;
`;
